import React from 'react';
import { MessageSquare, Phone } from 'lucide-react';
import { site } from '../data/site';
const steps = [{
  title: 'Call or text',
  text: `Reach ${site.contactName} at ${site.phone}.`
}, {
  title: 'Free walkthrough',
  text: 'We look at the space and price it out.'
}, {
  title: 'We paint',
  text: 'Prep, paint, clean up, done right.'
}];
export function EstimateCTA() {
  return <section id="quote" className="w-full bg-[#FACC15] py-16 lg:py-24" data-id="element-3" data-mp="6h0zljsax57a">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 lg:grid-cols-[1fr_1fr] lg:items-center lg:px-10" data-id="element-4" data-mp="6jdraonv2txj">
        <div data-id="element-5" data-mp="3swvgze2wdo3t">
          <h2 className="font-heading text-4xl font-black uppercase leading-[0.95] tracking-tight text-[#0B1B3A] sm:text-5xl lg:text-6xl" data-id="element-6" data-mp="3swly0ag9sh7m">
            Free estimate.
            <br data-id="element-7" data-mp="3nvpo9g98m0ua" />
            No obligation.
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-[#0B1B3A]/80" data-id="element-8" data-mp="3jv5qcaguat73">
            Call or text {site.contactName} and we'll set up a time that works
            for you — usually same week.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-9" data-mp="31yscqtlsisxg">
            <a href={site.phoneHref} className="flex items-center justify-center gap-3 bg-[#0B1B3A] px-8 py-5 font-heading text-lg font-black uppercase tracking-widest text-white hover:bg-[#132a5c]" data-id="element-10" data-mp="36rborm4txg05">
              <Phone className="h-5 w-5" aria-hidden="true" data-id="element-11" data-mp="2x1ibmgp1gsts" />
              {site.phone}
            </a>
            <a href={site.smsHref} className="flex items-center justify-center gap-3 border-4 border-[#0B1B3A] px-8 py-5 font-heading text-lg font-black uppercase tracking-widest text-[#0B1B3A] hover:bg-[#0B1B3A] hover:text-white" data-id="element-12" data-mp="3krmj4z5clcq2">
              <MessageSquare className="h-5 w-5" aria-hidden="true" data-id="element-13" data-mp="3gnwsm4544l2e" />
              Send a text
            </a>
          </div>
        </div>

        <ol className="space-y-4" data-id="element-14" data-mp="20dccg9avysmw">
          {steps.map((step, index) => <li key={step.title} className="flex items-start gap-5 border-4 border-[#0B1B3A] bg-[#FACC15] p-6" data-id="element-15" data-mp="25bdy91zp5622" data-mpi={index}>
              <span className="font-heading text-4xl font-black leading-none text-[#0B1B3A]/30" data-id="element-16" data-mp="5u9fjn9nuusb">
                {index + 1}
              </span>
              <div data-id="element-17" data-mp="1286ea7shk6i">
                <h3 className="font-heading text-xl font-black uppercase tracking-tight text-[#0B1B3A]" data-id="element-18" data-mp="11oo2se88try">
                  {step.title}
                </h3>
                <p className="mt-1 text-[#0B1B3A]/75" data-id="element-19" data-mp="3o9jwa40h5rxy">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}